/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
export default {
    'RevokeApiKey': {title: 'Revoke Api Key', icon: 'icon-revoke-api'},
    'UnlockUser': {title: 'Unlock User', icon: 'icon-unlock'},
    'ExpirePassword': {title: 'Expire Password', icon: 'icon-expire'},
    'UnexpirePassword': {title: 'Unexpire Password', icon: 'icon-unexpire'},
    'DeleteUser': {title: 'Delete User', icon: 'icon-clear'}
};


// WEBPACK FOOTER //
// ./constants/user_actions.constants.js